import React from 'react';
import { connect } from 'react-redux';
import TwoColumnRow from '../../../../tc-ui/two-column-row';
import MouseOverEditDiv from '../../../../tc-ui/mouse-over-edit-div';
import EditButton from '../../../generic-components/edit-button';
import EditSeasonButton from '../edit-season-button';
import DateUtils from '../../../../../utils/date-utils';
import ArrowRightIcon from 'material-ui/svg-icons/navigation/arrow-forward';
import moment from 'moment';
import A from 'aphrodite';
import R from 'ramda';

const styles = A.StyleSheet.create({
  addSeason: { textAlign: 'right', paddingRight: '4px' },
});

const _getDateFromUTC = date => {
  const dateObject = new Date(date);
  return new Date(dateObject.getUTCFullYear(), dateObject.getUTCMonth(), dateObject.getUTCDate());
};
const formatDate = date => moment(_getDateFromUTC(date)).format('D MMM YYYY');
const SeasonForSeasonRates = ({
  isNotContractingPeriod,
  existingSeasons = [],
  dateRanges = [],
  seasonName,
  seasonRatesIndex,
  deleteFromProduct,
  openAddEditContractDialog,
  supplierEditable,
  contractingPeriod,
  classes = {},
  openGlobalAlert,
}) => {
  const openEditSeasonModal = () => openAddEditContractDialog({
    type: 'editSeason',
    data: {
      seasonIndex: seasonRatesIndex,
      title: 'Edit Season',
    },
  });
  const isSpecialEventWithoutSingleEventName = !dateRanges.filter(dateRange => dateRange.eventName && (dateRange.seasonStartDate || dateRange.seasonEndDate)).length;
  const otherSeasons = R.remove(seasonRatesIndex, 1, existingSeasons);

  const formatSeasonStartAndEndDates = ({ seasonStartDate, seasonEndDate }, dateRangeIndex) => {
    const startClass = classes[`${dateRangeIndex}-seasonStartDate`];
    const endClass = classes[`${dateRangeIndex}-seasonEndDate`];
    const start = formatDate(seasonStartDate);
    const end = formatDate(seasonEndDate);
    if (seasonStartDate && seasonEndDate) {
      if (moment(seasonStartDate).isSame(seasonEndDate)) {
        return (
          <div
            key={dateRangeIndex}
            className={startClass}
          >
            {start}
          </div>);
      }
      return (
        <div key={dateRangeIndex}>
          <span className={startClass}>{start}</span> - <span className={endClass}>{end}</span>
        </div>
      );
    }
    if (seasonStartDate) return <span className={startClass}>{start}</span>;
    if (seasonEndDate) return <span className={endClass}>{end}</span>;
  };
  return (
    <MouseOverEditDiv
      extendPadding
      actionButtons={
        <EditButton
          onEdit={openEditSeasonModal}
          onDelete={() => {
            openGlobalAlert({
              text: 'Deleting this season will remove all rate sets and allocations associated with this season, are you sure you want to proceed?',
              onOk: () => deleteFromProduct({ seasonRatesIndex, contractingPeriod, updateType: 'DELETE_SEASON_FROM_PRODUCT' }),
            });
          }}
          deleteButton
        />}
      editable={supplierEditable}
      className={classes.main}
    >
    {
      seasonName === 'Special Event' && dateRanges.some(range => range.eventName) ?
        dateRanges.map((range, rangeIndex) => {
        const overlapped = supplierEditable && DateUtils.overlapExisting({ from: range.seasonStartDate, to: range.seasonEndDate }, otherSeasons);
          return (
            <div
              className={`season-start-and-end-dates ${classes[`${rangeIndex}-dateRange`]}`}
              style={{ marginBottom: rangeIndex === dateRanges.length - 1 ? '12px' : '0px' }}
              key={rangeIndex}
            >
              <TwoColumnRow
                outerContainerStyle={{ width: '100%', marginBottom: '0' }}
                leftColumnStyle={{ fontSize: '15px', color: 'black' }}
                leftColumnClassName={classes[`${rangeIndex}-eventName`]}
                leftColumnContent={isSpecialEventWithoutSingleEventName && !rangeIndex ? 'Special Event' : (range.eventName || '').toUpperCase()}
                rightColumnStyle={{ fontSize: '15px', color: 'black', marginLeft: 'auto' }}
                rightColumnContent={
                  (range.seasonStartDate || range.seasonEndDate) ? (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row-reverse',
                        alignItems: 'center',
                        whiteSpace: 'pre',
                        textAlign: 'right',
                        color: overlapped ? 'red' : '',
                      }}
                    >
                      {formatSeasonStartAndEndDates(range, rangeIndex)}
                      {
                        overlapped ? <ArrowRightIcon style={{ color: 'red' }}/> : <span/>
                      }
                    </div>) : (
                    <EditSeasonButton
                      existingSeasons={existingSeasons}
                      className={A.css(styles.addSeason)}
                      openAddEditContractDialog={openAddEditContractDialog}
                      seasonRatesIndex={seasonRatesIndex}
                      seasonName={seasonName}
                      dateRanges={dateRanges}
                    />
                  )
                }
              />
            </div>
          );
        }) : (
        <div className="season-start-and-end-dates">
          <TwoColumnRow
            outerContainerStyle={{ width: '100%', marginBottom: '0' }}
            leftColumnStyle={{ fontSize: '15px', color: 'black' }}
            leftColumnContent={isNotContractingPeriod ? seasonName.toUpperCase() : ''}
            rightColumnStyle={{ fontSize: '15px', color: 'black', marginLeft: 'auto' }}
            rightColumnContent={
              <div style={{ whiteSpace: 'pre', textAlign: 'right' }}>
                {
                  !(dateRanges && dateRanges.length && dateRanges.some(range => range.seasonStartDate)) ?
                    (<div className={A.css(styles.addSeason)} style={{ color: '#f44336' }}>
                      Update Season Dates
                    </div>) :
                    dateRanges.map((range, rangeIndex) => {
                      const overlapped = supplierEditable && DateUtils.overlapExisting({ from: range.seasonStartDate, to: range.seasonEndDate }, otherSeasons);
                      return (
                        <div
                          key={rangeIndex}
                          className={classes[`${rangeIndex}-dateRange`]}
                          style={{
                            display: 'flex',
                            flexDirection: 'row-reverse',
                            alignItems: 'center',
                            whiteSpace: 'pre',
                            textAlign: 'right',
                            color: overlapped ? 'red' : '',
                          }}
                        >
                          {formatSeasonStartAndEndDates(range, rangeIndex)}
                          {
                            overlapped ? <ArrowRightIcon style={{ color: 'red' }}/> : <span/>
                          }
                        </div>
                      );
                  })
                }
              </div>
            }
          />
        </div>)
    }
  </MouseOverEditDiv>);
};

const mapActions = ({
  openGlobalAlert: payload => ({
    type: 'open_global_alert',
    payload,
  }),
});
export default connect(null, mapActions)(SeasonForSeasonRates);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/product/left-column/season-for-seasonRates.jsx